export default "__VITE_ASSET__BCbA4fO7__"